module.exports = __webpack_public_path__ + "static/img/u1112.12b4159c.png";